'use strict';
module.exports = require('./src/autor.js');



// WEBPACK FOOTER //
// ../autor/index.js